j
<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 text-title">
      Renseignez vos coordonnées
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-6 user-informations">
        <small
          v-if="v$.customerFirstName.$invalid && v$.customerFirstName.$dirty"
          class="p-error"
        >
          Veuillez entrer un prénom<sup>*</sup>
        </small>
        <InputText
          type="text"
          v-model="customerFirstName"
          placeholder="Prénom*"
          :class="{
            'input-text': true,
            'p-invalid':
              v$.customerFirstName.$invalid && v$.customerFirstName.$dirty,
          }"
        />

        <small
          v-if="v$.customerLastName.$invalid && v$.customerLastName.$dirty"
          class="p-error"
        >
          Veuillez entrer un nom<sup>*</sup>
        </small>
        <InputText
          type="text"
          v-model="customerLastName"
          placeholder="Nom*"
          :class="{
            'input-text': true,
            'p-invalid':
              v$.customerLastName.$invalid && v$.customerLastName.$dirty,
          }"
        />

        <small
          v-if="
            v$.customerPhoneNumber.$invalid && v$.customerPhoneNumber.$dirty
          "
          class="p-error"
        >
          Veuillez entrer un numero de téléphone valide<sup>*</sup>
        </small>
        <InputText
          type="tel"
          v-model="customerPhoneNumber"
          placeholder="Numéro de téléphone*"
          :class="{
            'input-text': true,
            'p-invalid':
              v$.customerPhoneNumber.$invalid && v$.customerPhoneNumber.$dirty,
          }"
        />

        <small
          v-if="v$.customerEmail.$invalid && v$.customerEmail.$dirty"
          class="p-error"
        >
          Veuillez entrer un email valide<sup>*</sup>
        </small>
        <InputText
          type="email"
          v-model="customerEmail"
          placeholder="Email*"
          :class="{
            'input-text': true,
            'p-invalid': v$.customerEmail.$invalid && v$.customerEmail.$dirty,
          }"
        />

        <p class="sub-text">
          Êtes-vous assuré(e) bris de glace ?<sup>*</sup>&nbsp;<span
            class="pi pi-info-circle"
            v-tooltip="{ value: tooltip, escape: true }"
          ></span>
        </p>
        <small style="font-style: italic; font-weight: bold; color: black">
          Toutes assurances acceptées
        </small>

        <small
          v-if="v$.insurance.$invalid && v$.insurance.$dirty"
          class="p-error"
        >
          Veuillez selectionner une réponse
        </small>
        <div
          class="p-d-inline-flex p-jc-between p-my-6"
          style="width: 70%; margin: 5px 0px !important"
        >
          <div class="interventionSelectorItem">
            <RadioButton
              id="yes"
              name="insurance"
              value="1"
              v-model="insurance"
              class="p-my-3 p-my-sm-3"
            />
            <label for="yes" class="text-option">Oui</label>
          </div>
          <div class="interventionSelectorItem">
            <RadioButton
              id="no"
              name="insurance"
              value="2"
              v-model="insurance"
              class="p-my-3 p-my-sm-3"
            />
            <label for="no" class="text-option">Non</label>
          </div>
          <div class="interventionSelectorItem">
            <RadioButton
              id="unknown"
              name="insurance"
              value="3"
              v-model="insurance"
              class="p-my-3 p-my-sm-3"
            />
            <label for="unknown" class="text-option">Je ne sais pas</label>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-md-5 p-md-offset-1">
        <Card class="more-informations">
          <template #title>Informations facultatives</template>
          <template #content>
            <Textarea v-model="customerOptionalText" rows="5" cols="30" />
            <div class="p-grid file-upload-line">
              <div class="p-col-12 p-md-6" style="margin-top: 11px">
                Ajouter une photo du vitrage en entier
              </div>
              <div
                v-if="appointmentStore.appointment.picture_of_window != null"
                class="p-col"
              >
                <div class="p-grid file-upload-line">
                  <div class="p-col-10">
                    {{ appointmentStore.appointment.picture_of_window.name }}
                  </div>
                  <div class="p-col">
                    <i
                      class="pi pi-times"
                      @click="
                        appointmentStore.appointment.picture_of_window = null
                      "
                    />
                  </div>
                </div>
              </div>
              <div v-else class="p-col">
                <FileUpload
                  mode="basic"
                  name="vitrage[]"
                  chooseLabel="Parcourir"
                  :auto="true"
                  :customUpload="true"
                  @uploader="myUploaderPictureOfWindow"
                  accept="image/*,application/pdf"
                  :maxFileSize="5000000"
                />
              </div>
            </div>

            <div class="p-grid file-upload-line">
              <div class="p-col-12 p-md-6" style="margin-top: 11px">
                Ajouter une photo de votre carte grise
              </div>
              <div
                v-if="
                  appointmentStore.appointment
                    .picture_of_vehicle_registration_document != null
                "
                class="p-col"
              >
                <div class="p-grid file-upload-line">
                  <div class="p-col-10">
                    {{
                      appointmentStore.appointment
                        .picture_of_vehicle_registration_document.name
                    }}
                  </div>
                  <div class="p-col">
                    <i
                      class="pi pi-times"
                      @click="
                        appointmentStore.appointment.picture_of_vehicle_registration_document =
                          null
                      "
                    />
                  </div>
                </div>
              </div>
              <div v-else class="p-col">
                <FileUpload
                  mode="basic"
                  name="carte_grise[]"
                  chooseLabel="Parcourir"
                  :auto="true"
                  :customUpload="true"
                  @uploader="myUploaderPictureOfVehiculeRegistrationDocument"
                  accept="image/*,application/pdf"
                  :maxFileSize="5000000"
                />
              </div>
            </div>

            <div class="p-grid file-upload-line">
              <div class="p-col-12 p-md-6" style="margin-top: 11px">
                Ajouter une photo de votre assurance
              </div>
              <div
                v-if="appointmentStore.appointment.picture_of_insurance != null"
                class="p-col"
              >
                <div class="p-grid file-upload-line">
                  <div class="p-col-10">
                    {{ appointmentStore.appointment.picture_of_insurance.name }}
                  </div>
                  <div class="p-col">
                    <i
                      class="pi pi-times"
                      @click="
                        appointmentStore.appointment.picture_of_insurance = null
                      "
                    />
                  </div>
                </div>
              </div>
              <div v-else class="p-col">
                <FileUpload
                  mode="basic"
                  name="assurance[]"
                  chooseLabel="Parcourir"
                  :auto="true"
                  :customUpload="true"
                  @uploader="myUploaderPictureOfInsurance"
                  accept="image/*,application/pdf"
                  :maxFileSize="5000000"
                />
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>

    <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 50%">
      <div class="p-mt-sm-3 p-mr-5">
        <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
      </div>
      <div class="p-mt-sm-3">
        <Button class="button-navigate" @click="onNext">Suivant</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required, email, maxLength } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepClient",
  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const insurance = ref(null);
    const customerFirstName = ref("");
    const customerLastName = ref("");
    const customerPhoneNumber = ref(null);
    const customerEmail = ref("");
    const customerOptionalText = ref("");
    const phoneUtil =
      require("google-libphonenumber").PhoneNumberUtil.getInstance();
    const phoneValidator = () =>
      phoneUtil.isValidNumberForRegion(
        phoneUtil.parse(customerPhoneNumber.value, "FR"),
        "FR"
      );

    const rules = {
      customerFirstName: { required, maxLength: maxLength(80) },
      customerLastName: { required, maxLength: maxLength(80) },
      customerPhoneNumber: {
        required,
        phoneValidator,
        maxLength: maxLength(50),
      },
      customerEmail: { required, email },
      insurance: { required },
    };

    const v$ = useVuelidate(rules, {
      customerFirstName,
      customerLastName,
      customerPhoneNumber,
      customerEmail,
      insurance,
    });

    const getNextUrl = () => {
      let nextUrl = null;
      switch (insurance.value) {
        case "1":
          nextUrl = "/mon-rendez-vous";
          appointmentStore.appointment.broken_glass_insurance = true;
          break;
        case "2":
          nextUrl = "/devis-ou-rendez-vous";
          appointmentStore.appointment.broken_glass_insurance = false;
          break;
        case "3":
          nextUrl = "/devis-ou-rendez-vous";
          appointmentStore.appointment.broken_glass_insurance = null;
          break;
      }
      return nextUrl;
    };

    const onNext = () => {
      v$.value.$touch();
      if (!v$.value.$error) {
        const nextUrl = getNextUrl();
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;
        appointmentStore.appointment.firstname = customerFirstName.value;
        appointmentStore.appointment.lastname = customerLastName.value;
        appointmentStore.appointment.phone = customerPhoneNumber.value;
        appointmentStore.appointment.email = customerEmail.value;
        appointmentStore.appointment.additional_information = customerOptionalText.value;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/mes-coordonnees',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        if (appointmentStore.appointment.firstname) dataLayerToPush.firstname = appointmentStore.appointment.firstname;
        if (appointmentStore.appointment.lastname) dataLayerToPush.lastname = appointmentStore.appointment.lastname;
        if (appointmentStore.appointment.phone) dataLayerToPush.phone = appointmentStore.appointment.phone;
        if (appointmentStore.appointment.email) dataLayerToPush.email = appointmentStore.appointment.email;
        if (appointmentStore.appointment.additional_information) dataLayerToPush.additional_information = appointmentStore.appointment.additional_information;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };
    const onPrevious = () => {
      emit("prevPage", menuStore.currentMenuItem);
    };

    const tooltip = `
    <span style="text-decoration: underline;">Assuré bris de glace :</span><br>
    Nous nous occupons des démarches et l'assurance prendra en charge votre bris de glace.<br>
    <span style="text-decoration: underline;">Non assuré bris de glace :</span><br>
    Cliquez sur non et passez à l'étape suivante pour la réalisation de votre devis. (Facilités de paiement possibles)<br>
    <span style="text-decoration: underline;">Je ne sais pas :</span><br>
    Passez à l'étape suivante ou appelez-nous afin que nous puissions déterminer vos garanties bris de glace.
    `;

    const myUploaderPictureOfWindow = (event) => {
      appointmentStore.appointment.picture_of_window = event.files[0];
    };

    const myUploaderPictureOfVehiculeRegistrationDocument = (event) => {
      appointmentStore.appointment.picture_of_vehicle_registration_document =
        event.files[0];
    };

    const myUploaderPictureOfInsurance = (event) => {
      appointmentStore.appointment.picture_of_insurance = event.files[0];
    };

    return {
      onNext,
      insurance,
      onPrevious,
      customerFirstName,
      customerLastName,
      customerPhoneNumber,
      customerEmail,
      customerOptionalText,
      v$,
      tooltip,
      myUploaderPictureOfWindow,
      myUploaderPictureOfVehiculeRegistrationDocument,
      myUploaderPictureOfInsurance,
      appointmentStore,
    };
  },
};
</script>

<style>
.input-text {
  width: 100%;
  margin-bottom: 10px !important;
}
.interventionSelectorItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#input-text {
  margin: 10px 0px !important;
}
.sub-text {
  padding: 5px 0px 0px 0px !important;
  font-size: 1em !important;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}
.more-informations {
  margin-top: 10px !important;
  width: 100% !important;
  background-color: #f6f7f8 !important;
  border: 1px solid #24a285;
  box-shadow: none !important;
  border-radius: 0px !important;
}
.more-informations .p-card-content {
  color: black !important;
  text-align: center !important;
  padding: 15px !important;
  font-size: 1em !important;
  line-height: 1em !important;
  border-radius: 0px !important;
}
.more-informations .p-card-title {
  font-size: 1em !important;
  text-align: center !important;
  color: #24a285;
}
.file-upload-line {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px 0px !important;
}
.p-button-icon {
  color: white !important;
}
.pi-times {
  cursor: pointer !important;
}

@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .file-upload-line {
    font-size: .75rem;
  }
}
</style>
